
export default {
    name: 'LeeTimelineItem',
    data() {
        return {};
    },
    inject: ['timeline'],
    props: {
        timestamp: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: ''
        },
        xh: {
            type: Number,
            default: 0
        }

    },
    computed: {
        result() {
            if (this.timeline.reverse) {
                return this.xh >= this.timeline.totalnum - this.timeline.limitnum || this.timeline.limitnum == 0

            } else {
                return this.xh < this.timeline.limitnum || this.timeline.limitnum == 0

            }
        }

    },
    filters: {
        today: function (value) {
            value = value.slice(5)
            return value
        },
        toyear: function (value) {
            value = value.slice(0, 4)
            return value
        }
    }
};
